import { action } from 'satcheljs';
import { EditorServiceModels } from '@editor/client-rest-api';

export const setDefaultOptionWithId = action(
    'setDefaultOptionWithId',
    (id: string, categoryId: string, critiqueTypeInfo: EditorServiceModels.CritiqueTypeInfo) => ({
        id: id,
        categoryId: categoryId,
        critiqueTypeInfo: critiqueTypeInfo,
    })
);
